import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
  actionButton: {},
});
